import type { CSSProperties, JSX } from "react";

import { cn } from "@/shared/lib/cn";

interface SkeletonProps {
  className?: string;
  style?: CSSProperties;
}

export function Skeleton({ className, style }: SkeletonProps): JSX.Element {
  return (
    <div
      aria-hidden
      data-testid="skeleton"
      className={cn("animate-pulse rounded bg-[var(--surface-sunken)]", className)}
      style={style}
    />
  );
}
